import { useNavigate } from 'react-router';
import { useEffect, useState } from 'react';
import { IDashboardDrawBudget } from '@apply/api/src/api/DrawApi';
import { isMobileScreen } from '@apply/ui';
import { DrawSummaryPopup } from '@apply/ui/src/lib/tables/draws/drawsV2/DrawSummaryPopup';

interface DrawAddressLinkProps {
    dashboardDrawBudget: IDashboardDrawBudget;
}

export const DrawAddressLink: React.FC<DrawAddressLinkProps> = ({ dashboardDrawBudget }) => {
    const navigate = useNavigate();

    const [navigateToReviewAndSubmit, set_navigateToReviewAndSubmit] = useState(false);
    const [navigateToDraw, set_navigateToDraw] = useState(false);
    const [viewDraw, set_viewDraw] = useState(false);

    useEffect(() => {
        if (navigateToReviewAndSubmit) navigate(`/mobilereviewandsubmit/${dashboardDrawBudget.drawBudgetId}`);
    }, [navigateToReviewAndSubmit]);

    useEffect(() => {
        if (navigateToDraw) navigate(`/draw/${dashboardDrawBudget.drawBudgetId}`);
    }, [navigateToDraw]);

    const addressLinkText = () => {
        if (isMobileScreen() && dashboardDrawBudget.borrowerSubmitted && dashboardDrawBudget.canAddDraw === false) {
            set_navigateToReviewAndSubmit(true);
            return;
        }

        if (dashboardDrawBudget.canAddDraw) {
            set_viewDraw(true);
        } else {
            set_navigateToDraw(true);
            return;
        }
    };

    const shortAddress = dashboardDrawBudget.address.replace(/, *[^,]+$/, '');
    return (
        <div className='address'>
            <a onClick={addressLinkText}>{shortAddress}</a>
            {viewDraw && (
                <DrawSummaryPopup
                    drawBudgetId={dashboardDrawBudget.drawBudgetId}
                    drawHistoryLines={dashboardDrawBudget.drawHistoryLines}
                    open={true}
                    handleCloseEvent={() => set_viewDraw(false)}
                    tabShown={'funded'}
                />
            )}
        </div>
    );
};
